import styled from 'styled-components';
import { HTMLContainer } from './HtmlZone.style';
import { ConsentConfiguration } from '@luckycart/xpn-types';

interface ConsentsContainerProps {
  disabled?: boolean;
  suOptinForm?: boolean;
  computedConsents: ConsentConfiguration[];
}

export const ConsentsContainer = styled(HTMLContainer)<ConsentsContainerProps>`
  flex-direction: column;
  top: auto;
  bottom: 26vh;
  height: 17vh;
  overflow-y: auto;
  padding-top: 1vh;
  padding-bottom: 1vh;
  justify-content: flex-start;
  ${({ disabled }): string => {
    return disabled === true
      ? 'opacity: 0.2;'
      : '';
  }}

  &::-webkit-scrollbar {
    width: 1vw;
  }
  &::-webkit-scrollbar-track {
    background: #fff;
  }

  &::-webkit-scrollbar-thumb {
    background: #bdbdbd;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #bdbdbd;
  }

  ${(props): string => (props.suOptinForm === true ? `
	height: 19vh; 
	background-color: white;
	margin-left: 12vw;
	top: 48vh !important;
	width: 72vw;
  ` : '')}

  ${(props): string =>(
    props.computedConsents.length > 0 && props.computedConsents[0].type === 'toggle'
      ? 'top: 41vh !important; width: 100vw; margin: 5vh 0; height: 30vh !important;'
      : ''
  )}
`;
ConsentsContainer.displayName = 'ConsentsContainer';

export const CollectOptin = styled.div`
  font-size: 3vh;
  margin: 4vh 6vw 0;
`;
CollectOptin.displayName = 'CollectOptin';

export const CollectSmartOptin = styled.div`
  display: flex;
  background-color: white;
  padding: 0 1vw;
  width: auto;
  overflow: scroll;
  border-radius: 1vh;
`;
CollectSmartOptin.displayName = 'CollectSmartOptin';

export const CheckboxCollectOptin = styled.div`
  display: flex;
  align-items: center;
  font-size: 3vh;
  margin: 4vh 6vw 0;
  padding-left: 5vw;
  label {
    margin-left: 2vh;
  }
  input {
    width: 4vw;
    height: 4vh;
    border-radius: 20%;
    border: 1px solid #DCDCDC;
    background-color: white;
    -webkit-appearance: none;
    appearance: none;
  }
  input:hover {
    cursor: pointer;
  }
  input:checked {
    position: relative;
    border: 1px solid #005CAC;
    background: url("static-assets/checkbox.svg") #005CAC no-repeat center;
  }
  .checkmark {
    display: none;
    cursor: pointer;
  }
  input:checked ~ .checkmark {
    display: block;
    position: absolute;
    margin: 0 5px;
  }
`;
CheckboxCollectOptin.displayName = 'CheckboxCollectOptin';

export const Toggle = styled.div`
  display: flex;
  align-items: center;
  padding: 2vh 4vw 0;

  input {
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	width: 11vw;
	height: 5vh;
	display: inline-block;
	position: relative;
	border-radius: 50px;
	overflow: hidden;
	outline: none;
	border: none;
	cursor: pointer;
	background-color: #aeaeae;
	transition: background-color ease 0.3s;
  }

  input:before {
	content: "OUI NON";
	display: block;
	position: absolute;
	z-index: 2;
	width: 4vw;
	height: 4vh;
	background: #fff;
	left: 0.5vw;
	top: 0.5vh;
	border-radius: 50%;
	font: 2vw/4vw Helvetica;
	text-transform: uppercase;
	font-weight: bold;
	text-indent: -4.5vh;
	word-spacing: 5vw;
	color: #fff;
	white-space: nowrap;
	transition: all cubic-bezier(0.3, 1.5, 0.7, 1) 0.3s;
  }

  input:checked {
	background-color: rgb(33, 62, 255);
  }

  input:checked:before {
	left: 6.5vw;
  }

  p {
	display: flex;
	flex-direction: row;
  }

  span.toggleLabel {
	margin-right: 3.5vw;
	margin-left: 1vw;
	padding-top: 2.5vh;
	font-weight: 700;
	font-size: 3.5vh;
	line-height: 1vh;
	text-align: center;
  }
`;
Toggle.displayName = 'Toggle';